import React from 'react';
import TimelineActu from '../../fil-actu/components/TimelineActu';
import ProfileBestPhotos from "./ProfileBestPhotos";
import ProfileBestVideos from "./ProfileBestVideos";
import {config} from "../../../../config";
import _ from "lodash";
import {canonical} from "../../../../libs/helper";
import createLink from "../../../../libs/createLink";
import Helmet from "react-helmet";


const Home = (props) => {

    return (
        <div className="profil-home">
            <Helmet>
                {props.isMe ? (
                    <title>{config.preTitle}Mon profil{config.postTitle}</title>
                ) : (
                    <title>Profil Voissa de {props.user.username}</title>

                )}
                <meta name="description"
                      content={(_.get(props.user, "profile.description") || "").substring(0, 140)}/>
                <link rel="canonical" href={canonical(createLink('userProfile', props.user), "", "profile")}/>

            </Helmet>
            <ProfileBestPhotos user={props.user} isMe={props.isMe}/>
            <ProfileBestVideos user={props.user} isMe={props.isMe}/>
            <TimelineActu currentUser={props.currentUser}
                          userId={props.user._id}
                          isMe={props.isMe}
            />
        </div>
    )
}

export default Home;
